import React, { useState } from 'react';
import { connect } from 'react-redux';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import legalFiles from '../../assets/legal-files.zip';

import { 
    rowContainsError, 
    rowIsIncomplete
} from '../../Utils';

import './DownloadFilesButton.css'

const DownloadFilesButton = ({ pdfBlob, invoiceFileName, disable }) => {

    const [showErrorPopup, setShowErrorPopup] = useState(false);

    const download = blob => {

        JSZipUtils.getBinaryContent(legalFiles, function (err, data) {
            if (err) {
                alert('An unknown error ocurred.');
            }

            JSZip.loadAsync(data)
                .then(data => data.file(`${invoiceFileName}.pdf`, blob))
                .then(zip => {
                    zip.generateAsync({ type: "blob" })
                        .then(function (content) {
                            saveAs(content, `${invoiceFileName}-Bundle.zip`);
                        });
                });
        });
    }

    let classNames = ['download-button'];
    if (disable) classNames.push('disabled');

    const disableDescription = disable === 'error' ? 'Form still contains errors!'
        : disable === 'incomplete' ? 'Form is incomplete!' : null

    return (
        <button
            className={classNames.join(' ')}
            onClick={disable ? null : () => download(pdfBlob)}
            onMouseOver={() => setShowErrorPopup(true)}
            onMouseOut={() => setShowErrorPopup(false)}
        >Download Now! <span className={showErrorPopup && disable ? 'show-error-popup' : ''}>{disableDescription}</span></button>

    )
}

const mapStateToProps = state => ({
    disable: !!state.interestForm.rowData.find(rowContainsError) ? 'error'
        : !!state.interestForm.rowData.find(rowIsIncomplete) ? 'incomplete'
        : null
})

export default connect(
    mapStateToProps
)(DownloadFilesButton)